import React from 'react';
import Card from '../common/Card';
import CopyButton from '../common/CopyButton';

const ReferralLink = ({ userId }) => {
  const baseUrl = typeof window !== 'undefined'
    ? `${window.location.protocol}//${window.location.host}`
    : '';
  const link = `${baseUrl}/register?ref=${userId}`;

  return (
    <Card title="Your Referral Link" subtitle="Share this link to invite new members" glow>
      <div className="referral-link-box">
        <div className="link-text">{link}</div>
        <CopyButton text={link} />
      </div>
      <div className="mt-md flex gap-sm items-center">
        <span className="text-muted" style={{ fontSize: 13 }}>Your ID:</span>
        <span className="badge badge-aurora">{userId}</span>
        <CopyButton text={String(userId)} label="Copy ID" />
      </div>
    </Card>
  );
};

export default ReferralLink;
